import { User } from '@vsf-enterprise/sap-commerce-webservices-sdk';
import { Context } from '@vue-storefront/core';
import { RegisterUserProps } from 'composables/src/types';

export const registerUser = async (
  context: Context,
  customer: RegisterUserProps
): Promise<User> => {
  return context.$sapcc.api.createUser(customer);
};
